const analytics = require('./analytics')
const appointments = require('./appointments')
const askkeelearning = require('./askkeelearning')
const auth = require('./auth')
const chat = require('./chat')
const comments = require('./comments')
const communities = require('./communities')
const competitions = require('./competitions')
const courses = require('./courses')
const deepstream = require('./deepstream')
const emojiPicker = require('./emojiPicker')
const errors = require('./errors')
const feedback = require('./feedback')
const fileUploads = require('./fileUploads')
const forms = require('./forms')
const generic = require('./generic')
const homeComponents = require('./homeComponents')
const learnCards = require('./learnCards')
const learningpath = require('./learningpath')
const nav = require('./nav')
const news = require('./news')
const notifications = require('./notifications')
const notificationSettings = require('./notificationSettings')
const pages = require('./pages')
const powerlearning = require('./powerlearning')
const quizapp = require('./quizapp')
const tests = require('./tests')
const todolists = require('./todolists')
const vouchers = require('./vouchers')
const webinars = require('./webinars')

module.exports = {
  analytics,
  appointments,
  askkeelearning,
  auth,
  comments,
  communities,
  competitions,
  courses,
  deepstream,
  errors,
  feedback,
  forms,
  generic,
  homeComponents,
  learnCards,
  learningpath,
  nav,
  news,
  notifications,
  notificationSettings,
  pages,
  powerlearning,
  quizapp,
  tests,
  todolists,
  vouchers,
  webinars,
  chat,
  fileUploads,
  emojiPicker,
}
